// @flow

import { request } from '../../utils'

const localeToUrl = {
  de_DE: '/on/demandware.store/Sites-skc-de-Site/de_DE/Cart-AddProduct?ajax=true',
  nl_NL: '/on/demandware.store/Sites-skc-nl-Site/nl_NL/Cart-AddProduct?ajax=true',
  de_CH: '/on/demandware.store/Sites-skc-ch-Site/de_CH/Cart-AddProduct?ajax=true',
  fr_CH: '/on/demandware.store/Sites-skc-ch-Site/fr_CH/Cart-AddProduct?ajax=true'
}

export function addToCartSkinceuticalsByLocale (locale: $Keys<typeof localeToUrl>): Function {
  return function addToCartSkinceuticals (customerId: string, subscriberId: string, productId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      request({
        url: localeToUrl[locale],
        data: {
          pid: productId,
          quantity: '1'
        },
        processResponse: (xhr) => {
          if (xhr.status >= 200 && xhr.status < 400) {
            resolve()
          } else {
            reject(new Error('Add-to-cart failed.'))
          }
        }
      })
    })
  }
}
